export default "__VITE_ASSET__V4t8L6_T__"